import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

const timeList = [
  "12:00 AM",
  "12:30 AM",
  "01:00 AM",
  "01:30 AM",
  "02:00 AM",
  "02:30 AM",
  "03:00 AM",
  "03:30 AM",
  "04:00 AM",
  "04:30 AM",
  "05:00 AM",
  "05:30 AM",
  "06:00 AM",
  "06:30 AM",
  "07:00 AM",
  "07:30 AM",
  "08:00 AM",
  "08:30 AM",
  "09:00 AM",
  "09:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
  "05:00 PM",
  "05:30 PM",
  "06:00 PM",
  "06:30 PM",
  "07:00 PM",
  "07:30 PM",
  "08:00 PM",
  "08:30 PM",
  "09:00 PM",
  "09:30 PM",
  "10:00 PM",
  "10:30 PM",
  "11:00 PM",
  "11:30 PM",
];

const CarPickupLocation = ({ setTimeValue, timeValue, cityQuery }) => {
  
  const handleAutocompleteChange = (event, value) => {
    setTimeValue(value);
  };

  return (
    <>
      <Box
        className={`searchMenu-loc lg:px-0 js-form-dd`}
        sx={{
          width: "100%",
          "& label.Mui-focused": {
            color: "black",
          },
          "& .MuiInputBase-input": {
            // height: "16px",
          },
          "& .MuiAutocomplete-clearIndicator": {
            display: "none", // Hides the clear (close) button
          },

          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiInput-underline:after": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
              borderRadius: "8px",
            },
            "&:hover fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
          },
        }}
      >
        {/* <label>Destination</label> */}
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          value={timeValue}
          options={timeList}
          onChange={handleAutocompleteChange}
          renderInput={(params) => (
            <TextField {...params} placeholder="Pickup Location" />
          )}
        />
      </Box>
    </>
  );
};

export default CarPickupLocation;